import { Component, OnDestroy, Signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  ApplicationAppEntityApplicationRead
} from '../../../../../../openapi';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { stages } from '../../placement-advertising.routes';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {
  AdPlacementRoadOccupationForm,
  occupationsToAdPlacementRoadOccupationFormValues
} from './forms/ad-placement-road-occupation.form';
import {
  AdPlacementRoadOccupationFormComponent
} from './components/ad-placement-road-occupation-form/ad-placement-road-occupation-form.component';
import { updateAdPlacementOccupations } from '../../../../../../store/actions/application.actions';

@Component({
  selector: 'app-ad-placement-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    ReactiveFormsModule,
    CommonModule,
    AdPlacementRoadOccupationFormComponent
  ],
  providers: [
    AdPlacementRoadOccupationForm
  ],
  templateUrl: './ad-placement-section.component.html'
})
export class AdPlacementSectionComponent implements OnDestroy {

  public stages: string[] = stages;

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  private fetchOccupations: Subscription = toObservable(this.application).subscribe((app) => {
    const occupation = occupationsToAdPlacementRoadOccupationFormValues(app).at(0) || null;
    if (occupation) {
      this.form.patchFormValues(occupation);
    }
  });

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store$: Store,
    public form: AdPlacementRoadOccupationForm
  ) {
  }

  public onCancel(): void {
    this.router.navigate(['../inwestor'], { relativeTo: this.route });
  }

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.store$.dispatch(updateAdPlacementOccupations({
          application: this.application(),
          occupations: [this.form.values],
          successFnc: () => {
            this.router.navigate(
              ['../oplaty'],
              {
                relativeTo: this.route
              }
            );
          },
          failureFnc: () => {
          }
        })
      );
    } else {
      this.form.markAllAsTouched();
    }
  }

  public ngOnDestroy(): void {
    this.fetchOccupations.unsubscribe();
  }
}
